/** @jsxImportSource @emotion/react */
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

import { RootState } from '@state-mgmt/store';
import { styles } from './styles';
import { SITE_MODE } from '@hooks/modals/useOnSiteModal';

export interface Props {
  onClose: () => void;
  setSiteMode: (mode: SITE_MODE ) => void;
  siteMode: SITE_MODE
}

const OnSiteModal = ({ setSiteMode, siteMode, onClose }: Props) => {
  const { t } = useTranslation();
  const { themeMode } = useSelector((state: RootState) => state.app);

  return (
    <div css={styles.container(themeMode)}>
      <DialogTitle> {t('on-site.title')}</DialogTitle>
      <DialogContent>
        <Typography>{t('on-site.description')}</Typography>

        <FormControl>
          <RadioGroup
            value={siteMode}
            onChange={(e) => setSiteMode(e.target.value as SITE_MODE)}
          >
            <FormControlLabel
              value={SITE_MODE.ON}
              checked={siteMode === SITE_MODE.ON}
              control={<Radio />}
              label={t('general.yes')}
            />
            <FormControlLabel
            checked={siteMode === SITE_MODE.OFF}
              value={SITE_MODE.OFF}
              control={<Radio />}
              label={t('general.no')}
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions css={styles.actionsContainer}>

        <Button variant="contained" onClick={onClose}>
          {t('general.confirm')}
        </Button>
      </DialogActions>
    </div>
  );
};

export default OnSiteModal;
